module.exports = __webpack_public_path__ + "static/media/Massless-Spiral-2Loops.9ca39d39.gif";